import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenService } from 'services/token/token.service';
import { EntryService } from 'services/entry/entry.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import _get from 'lodash-es/get';
import { TokenStorageService } from 'services/token/token-storage.service';

@UntilDestroy()
@Component({
  selector: 'cm-change-email',
  template: '',
})
export class ChangeEmailComponent implements OnInit, OnDestroy {
  constructor(
    private tokenService: TokenService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private entryService: EntryService,
    private tokenStorageService: TokenStorageService,
  ) {}

  ngOnInit() {
    const { params, queryParams } = this.activatedRouter.snapshot;
    const token = _get(params, 'token');
    let profileId = _get(queryParams, 'profileId', null);
    if (profileId) {
      profileId = Number(profileId);
    }
    this.tokenService
      .changeUserEmail({ token, profileId })
      .pipe(
        untilDestroyed(this),
        catchError((err) => {
          const text = _get(err, 'body.error_message');
          if (text) {
            this.entryService.setMessageType({ msg: 'CUSTOM_ERROR', text, email: true });
            this.router.navigate(['/entry/message']);
          }
          return of('error');
        }),
      )
      .subscribe((data) => {
        if (data === 'error') {
          return;
        }
        this.tokenStorageService.dropAllTokens();
        const email = _get(data, 'email', '');
        this.entryService.setMessageType({ email, login: true });
        this.router.navigate(['/entry/login']);
      });
  }

  ngOnDestroy() {}
}
